<template>
  <div class="order-container">
    <el-empty v-if="!order" description="暂无数据"/>
    <div v-else class="order-info">
      <div class="info-item">订单编号: {{ order.orderNo }}</div>
      <div class="info-item">创建时间: {{ order.createTime }}</div>
      <div class="info-item">业务员姓名: {{ order.salesmanName }}</div>
      <div class="info-item">归属: {{ order.belongToName }}</div>
      <div class="info-item">放款流程: {{ order.lendingModeName }}</div>
      <div class="info-item">订单状态: {{ $dict.nameOf('order_status', order.status) }}</div>
      <div class="info-item">是否抵押: {{ $dict.nameOf('yes_no', order.isHock) }}</div>
      <div class="info-item">是否放款: {{ $dict.nameOf('yes_no', order.isLending) }}</div>
      <div class="info-item">资料是否归档: {{ $dict.nameOf('yes_no', order.isArchive) }}</div>
      <div class="info-item">是否收车: {{ $dict.nameOf('yes_no', order.isCar) }}</div>
      <div class="info-item">取消状态: {{ $dict.nameOf('order_cancel_status', order.cancelStatus) }}</div>
      <div class="info-item">拒绝类型: {{ $dict.nameOf('order_reject_status', order.rejectStatus) }}</div>
      <div class="info-item">贷后状态: {{ $dict.nameOf('order_after_status', order.afterStatus) }}</div>
      <div class="info-item">备注: {{ order.description }}</div>
      <div class="info-block" v-if="String(order.isLending) === '1'">
        <div class="info-line">放款凭证:</div>
        <div class="info-line-file" v-for="(item, index) in lendingProof" :key="index">
          <a :href="item" target="_blank">{{ getFileName(item) }}</a>
        </div>
        <div class="info-line">放款描述: {{ order.lendingDesc }}</div>
      </div>
      <div class="info-block" v-if="String(order.isArchive) === '1'">
        <div class="info-line">归档凭证:
          <div class="info-line-file" v-for="(item, index) in archiveProof" :key="index">
            <a :href="item" target="_blank">{{ getFileName(item) }}</a>
          </div>
        </div>
        <div class="info-line">归档描述: {{ order.archiveDesc }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderBase",
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  computed: {
    lendingProof() {
      return this.order.lendingProof ? this.order.lendingProof.split(',') : [];
    },
    archiveProof() {
      return this.order.archiveProof ? this.order.archiveProof.split(',') : [];
    }
  },
  methods: {
    getFileName(fileUrl) {
      if (typeof fileUrl !== 'string') {
        console.warn('fileUrl is not a string:', fileUrl);
        return '';
      }
      if (!fileUrl) {
        return '';
      }
      if (fileUrl.lastIndexOf('?') === -1) {
        return fileUrl.substring(fileUrl.lastIndexOf('/') + 1);
      } else {
        return fileUrl.substring(fileUrl.lastIndexOf('?') + 1);
      }
    }
  }
}
</script>

<style scoped>
.info-block {
  flex-basis: calc(100% - 20px);
  box-sizing: border-box;
  min-width: 200px;

  .info-line {
    display: flex;
    flex-wrap: wrap;
    flex-basis: calc(50% - 20px);
    box-sizing: border-box;
    min-width: 200px;
    margin: 10px;
  }
  .info-line-file {
    width: 100%;
    display: inline-block;
    min-width: 200px;
    margin: 10px;
  }
}
</style>
